import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['modal', 'form', 'errors', 'submitButton', 'submitText', 'submitSpinner']
  static values = { productId: String }

  connect () {
    this.boundHandleEscape = this.handleEscape.bind(this)
  }

  open () {
    this.modalTarget.classList.remove('hidden')
    document.body.style.overflow = 'hidden'
    document.addEventListener('keydown', this.boundHandleEscape)

    // Focus first input
    const firstInput = this.formTarget.querySelector('input[type="text"]')
    if (firstInput) {
      setTimeout(() => firstInput.focus(), 100)
    }
  }

  close () {
    this.modalTarget.classList.add('hidden')
    document.body.style.overflow = 'auto'
    document.removeEventListener('keydown', this.boundHandleEscape)

    // Reset form
    this.formTarget.reset()
    this.hideErrors()
    this.resetSubmitButton()
  }

  handleEscape (event) {
    if (event.key === 'Escape') {
      this.close()
    }
  }

  async submit (event) {
    event.preventDefault()

    this.showLoading()
    this.hideErrors()

    const formData = new FormData(this.formTarget)

    try {
      const response = await fetch(`/products/${this.productIdValue}/reservations`, {
        method: 'POST',
        body: formData,
        headers: {
          'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content,
          Accept: 'application/json'
        }
      })

      const data = await response.json()

      if (data.success) {
        this.showSuccess(data.message)
        this.close()
      } else {
        this.showErrors(data.errors)
      }
    } catch (error) {
      console.error('Reservation error:', error)
      this.showErrors(['Произошла ошибка при отправке запроса. Попробуйте еще раз.'])
    } finally {
      this.resetSubmitButton()
    }
  }

  showLoading () {
    this.submitButtonTarget.disabled = true
    this.submitTextTarget.textContent = 'Отправка...'
    this.submitSpinnerTarget.classList.remove('hidden')
  }

  resetSubmitButton () {
    this.submitButtonTarget.disabled = false
    this.submitTextTarget.textContent = 'Забронировать'
    this.submitSpinnerTarget.classList.add('hidden')
  }

  showErrors (errors) {
    const errorsContainer = this.errorsTarget
    const errorsList = errorsContainer.querySelector('ul')

    errorsList.innerHTML = ''
    errors.forEach(error => {
      const li = document.createElement('li')
      li.textContent = error
      errorsList.appendChild(li)
    })

    errorsContainer.classList.remove('hidden')
  }

  hideErrors () {
    this.errorsTarget.classList.add('hidden')
  }

  showSuccess (message) {
    // Create success notification
    const notification = document.createElement('div')
    notification.className = 'fixed top-4 right-4 bg-green-500 text-white px-6 py-3 rounded-lg shadow-lg z-50'
    notification.innerHTML = `
      <div class="flex items-center gap-2">
        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
        </svg>
        ${message}
      </div>
    `

    document.body.appendChild(notification)

    // Remove after 5 seconds
    setTimeout(() => {
      notification.remove()
    }, 5000)
  }
}
